<template>
  <div class="shop-management-page">
    <div class="settings-card">
      <h2 class="page-title">
        <Icon icon="heroicons:shopping-bag" width="24" height="24" />
        商品挂载分类管理
      </h2>

      <!-- 搜索区域 -->
      <div class="search-bar">
        <div class="search-left">
          <el-input v-model="searchForm.name" placeholder="请输入分类名称" clearable size="large" class="search-input"
            @keyup.enter="handleSearch">
            <template #prefix>
              <Icon icon="heroicons:magnifying-glass" width="18" height="18" />
            </template>
          </el-input>

          <el-button type="primary" size="large" @click="handleSearch" class="search-btn">
            <Icon icon="heroicons:magnifying-glass" width="18" height="18" />
            <span class="btn-text">搜索</span>
          </el-button>
        </div>

        <el-button type="success" size="large" @click="openAddDialog" class="add-btn">
          <Icon icon="heroicons:plus" width="18" height="18" />
          <span class="btn-text">新增分类</span>
        </el-button>
      </div>

      <!-- 表格包装器 -->
      <div class="table-wrapper">
        <el-table :data="categoryList" stripe v-loading="loading" class="shop-table"
          :row-style="{ background: 'transparent' }" :cell-style="{ background: 'transparent' }"
          :header-cell-style="{ background: 'rgba(157, 78, 221, 0.15)', color: '#fff' }">
          <el-table-column prop="id" label="ID" width="80" />
          <el-table-column prop="name" label="分类名称" width="180" />
          <el-table-column prop="notes" label="备注" min-width="200" show-overflow-tooltip />
          <el-table-column prop="create_time" label="创建时间" width="180" />
          <el-table-column prop="update_time" label="更新时间" width="180" />

          <el-table-column label="商品列表" width="150" fixed="right">
            <template #default="scope">
              <button class="action-btn view-btn" @click="openRecordDialog(scope.row)">
                <Icon icon="heroicons:eye" width="14" height="14" />
                查看商品
              </button>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="200" fixed="right">
            <template #default="scope">
              <button class="action-btn edit-btn" @click="openEditDialog(scope.row)">
                <Icon icon="heroicons:pencil-square" width="14" height="14" />
                <span class="btn-text">编辑</span>
              </button>
              <button class="action-btn delete-btn" @click="handleDelete(scope.row.id)">
                <Icon icon="heroicons:trash" width="14" height="14" />
                <span class="btn-text">删除</span>
              </button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页组件 -->
      <div class="pagination-container">
        <el-pagination v-model:current-page="pagination.page" v-model:page-size="pagination.pageSize"
          :total="pagination.total" :page-sizes="[10, 20, 30, 50]" :layout="paginationLayout"
          @size-change="fetchCategoryList" @current-change="fetchCategoryList" background />
      </div>
    </div>

    <!-- 新增/编辑对话框 -->
    <el-dialog v-model="dialogVisible" :title="dialogTitle" :width="dialogWidth" :close-on-click-modal="false"
      class="custom-dialog" :top="dialogTop">
      <el-form ref="categoryForm" :model="categoryForm" :label-width="formLabelWidth" :rules="formRules">
        <el-form-item label="分类名称" prop="name">
          <el-input v-model="categoryForm.name" placeholder="请输入分类名称" size="large" />
        </el-form-item>
        <el-form-item label="备注信息">
          <el-input v-model="categoryForm.notes" placeholder="请输入备注信息" type="textarea" :rows="3" />
        </el-form-item>
      </el-form>
      <template #footer>
        <button class="dialog-btn cancel-btn" @click="dialogVisible = false">取消</button>
        <button class="dialog-btn confirm-btn" @click="submitCategoryForm">确认</button>
      </template>
    </el-dialog>

    <!-- 查看商品对话框 -->
    <el-dialog v-model="recordDialogVisible" :title="recordDialogTitle" :width="childDialogWidth" top="5vh"
      :close-on-click-modal="false" :lock-scroll="false" :append-to-body="true"
      class="custom-dialog parent-view-dialog">
      <MountingRecordView v-if="recordDialogVisible" :shop-id="currentShopId" :store-id="userInfo.id" />
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import config from '@/config.js';
import Cookies from 'js-cookie';
import { Icon } from '@iconify/vue';
import MountingRecordView from '@/components/MountingShopRecordView.vue'
import { ElMessage, ElMessageBox } from 'element-plus';

export default {
  name: 'MountingShopGz',
  components: { Icon, MountingRecordView },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      recordDialogVisible: false,
      dialogTitle: '新增分类',
      recordDialogTitle: '',
      isEditMode: false,
      currentShopId: null,
      searchForm: {
        name: ''
      },
      categoryForm: {
        id: null,
        name: '',
        notes: ''
      },
      formRules: {
        name: [
          { required: true, message: '请输入分类名称', trigger: 'blur' }
        ]
      },
      categoryList: [],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      screenWidth: window.innerWidth
    }
  },
  computed: {
    userInfo() {
      return JSON.parse(Cookies.get('user_info') || '{}')
    },
    paginationLayout() {
      if (this.screenWidth < 576) return 'prev, pager, next'
      if (this.screenWidth < 768) return 'total, prev, pager, next'
      return 'total, sizes, prev, pager, next, jumper'
    },
    dialogWidth() {
      if (this.screenWidth < 576) return '95%'
      if (this.screenWidth < 768) return '90%'
      return '600px'
    },
    childDialogWidth() {
      if (this.screenWidth < 576) return '95%'
      if (this.screenWidth < 768) return '90%'
      return '1200px'
    },
    dialogTop() {
      if (this.screenWidth < 576) return '5vh'
      return '10vh'
    },
    formLabelWidth() {
      if (this.screenWidth < 576) return '80px'
      return '100px'
    }
  },
  mounted() {
    this.fetchCategoryList();
    window.addEventListener('resize', this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.screenWidth = window.innerWidth
    },
    openRecordDialog(row) {
      this.currentShopId = row.id;
      this.recordDialogTitle = `${row.name} - 商品列表`;
      this.recordDialogVisible = true;
    },
    async fetchCategoryList() {
      this.loading = true;
      try {
        const params = {
          action: this.searchForm.name ? 'search' : 'list',
          store_id: this.userInfo.id,
          page: this.pagination.page,
          page_size: this.pagination.pageSize
        };
        if (this.searchForm.name) {
          params.keyword = this.searchForm.name;
        }
        const { data } = await axios.post(
          `${config.BASE_URL}/shop/api/shop_mounting_management.php`,
          params
        );
        if (data.data) {
          this.categoryList = data.data;
          this.pagination.total = data.pagination?.total || data.data.length;
        }
      } catch (error) {
        ElMessage.error('获取分类列表失败');
        console.error('获取分类列表错误:', error);
      } finally {
        this.loading = false;
      }
    },
    handleSearch() {
      this.pagination.page = 1;
      this.fetchCategoryList();
    },
    openAddDialog() {
      this.dialogTitle = '新增分类';
      this.isEditMode = false;
      this.categoryForm = {
        id: null,
        name: '',
        notes: ''
      };
      this.dialogVisible = true;
    },
    openEditDialog(row) {
      this.dialogTitle = '编辑分类';
      this.isEditMode = true;
      this.categoryForm = {
        id: row.id,
        name: row.name,
        notes: row.notes
      };
      this.dialogVisible = true;
    },
    submitCategoryForm() {
      this.$refs.categoryForm.validate(async (valid) => {
        if (valid) {
          try {
            const action = this.isEditMode ? 'update' : 'add';
            const { data } = await axios.post(
              `${config.BASE_URL}/shop/api/shop_mounting_management.php`,
              {
                action,
                ...this.categoryForm,
                store_id: this.userInfo.id
              }
            );
            if (data.success) {
              ElMessage.success(this.isEditMode ? '更新成功' : '添加成功');
              this.dialogVisible = false;
              this.fetchCategoryList();
            } else {
              ElMessage.error(data.error || '操作失败');
            }
          } catch (error) {
            const errorMsg = error.response?.data?.error || error.message || '操作失败';
            ElMessage.error(`操作失败: ${errorMsg}`);
            console.error('表单提交错误:', error);
          }
        }
      });
    },
    async handleDelete(id) {
      try {
        await ElMessageBox.confirm('确定要删除该分类吗？删除后关联的商品记录也将被删除', '警告', {
          confirmButtonText: '确认删除',
          cancelButtonText: '取消',
          type: 'warning'
        });
        const { data } = await axios.post(
          `${config.BASE_URL}/shop/api/shop_mounting_management.php`,
          {
            action: 'delete',
            id: id,
            store_id: this.userInfo.id
          }
        );
        if (data.success) {
          ElMessage.success('删除成功');
          this.fetchCategoryList();
        } else {
          ElMessage.error(data.error || '删除失败');
        }
      } catch (error) {
        if (error !== 'cancel') {
          const errorMsg = error.response?.data?.error || error.message || '删除失败';
          ElMessage.error(`删除失败: ${errorMsg}`);
          console.error('删除错误:', error);
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.shop-management-page {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
}

.settings-card {
  background: rgba(18, 14, 33, 0.6);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  border: 1px solid rgba(157, 78, 221, 0.2);
  padding: 24px;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 16px;
  }

  @media (max-width: 576px) {
    padding: 12px;
  }
}

.page-title {
  font-size: 20px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  gap: 10px;

  svg {
    color: #c084fc;
  }

  @media (max-width: 768px) {
    font-size: 18px;
    margin-bottom: 16px;
  }
}

.search-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 20px;

  .search-left {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
    flex: 1;
  }

  .search-input {
    flex: 1;
    min-width: 200px;
  }

  @media (max-width: 768px) {
    flex-direction: column;

    .search-left {
      width: 100%;
    }

    .search-left .el-input {
      width: 100% !important;
    }

    .search-left .search-btn {
      width: 100%;
    }

    .add-btn {
      width: 100%;
    }
  }
}

.table-wrapper {
  position: relative;
  width: 100%;
  overflow-x: auto;
  margin-top: 20px;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    height: 8px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(157, 78, 221, 0.1);
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(157, 78, 221, 0.4);
    border-radius: 4px;

    &:hover {
      background: rgba(157, 78, 221, 0.6);
    }
  }
}

:deep(.el-table) {
  --el-table-bg-color: transparent !important;
  --el-table-tr-bg-color: transparent !important;
  --el-table-header-bg-color: transparent !important;
  --el-table-row-hover-bg-color: rgba(157, 78, 221, 0.1) !important;
  --el-table-current-row-bg-color: rgba(157, 78, 221, 0.15) !important;
  --el-table-stripe-row-bg-color: rgba(157, 78, 221, 0.05) !important;
  --el-table-border-color: rgba(157, 78, 221, 0.2) !important;

  background-color: transparent !important;
  color: #e0e0e0;

  &::before {
    display: none;
  }

  .el-table__header-wrapper {
    background-color: transparent !important;

    tr {
      background-color: transparent !important;

      th:not(.el-table-fixed-column--right) {
        background: rgba(157, 78, 221, 0.2) !important;
        color: #fff !important;
        font-weight: 600;
        border-bottom: 1px solid rgba(157, 78, 221, 0.3) !important;

        .cell {
          color: #fff !important;
        }
      }
    }
  }

  .el-table__body-wrapper {
    background-color: transparent !important;

    tr {
      background-color: transparent !important;

      td:not(.el-table-fixed-column--right) {
        background-color: transparent !important;
        border-bottom: 1px solid rgba(157, 78, 221, 0.1);
        color: #e0e0e0;
      }

      &.el-table__row--striped td:not(.el-table-fixed-column--right) {
        background-color: rgba(157, 78, 221, 0.05) !important;
      }

      &:hover td:not(.el-table-fixed-column--right) {
        background-color: rgba(157, 78, 221, 0.1) !important;
      }
    }
  }

  .el-table-fixed-column--right {
    background-color: #120e21 !important;
    backdrop-filter: none !important;
  }

  th.el-table-fixed-column--right {
    background-color: #2a1f45 !important;
  }

  .el-table__row--striped .el-table-fixed-column--right {
    background-color: #1a1430 !important;
  }

  .el-table__empty-block {
    background-color: transparent !important;

    .el-table__empty-text {
      color: #a0a0c0 !important;
    }
  }
}

.action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  margin: 0 4px;

  &.view-btn {
    background: rgba(157, 78, 221, 0.15);
    border: 1px solid rgba(157, 78, 221, 0.4);
    color: #c084fc;

    &:hover {
      background: rgba(157, 78, 221, 0.25);
    }
  }

  &.edit-btn {
    background: rgba(157, 78, 221, 0.15);
    border: 1px solid rgba(157, 78, 221, 0.4);
    color: #c084fc;

    &:hover {
      background: rgba(157, 78, 221, 0.25);
    }
  }

  &.delete-btn {
    background: rgba(239, 68, 68, 0.15);
    border: 1px solid rgba(239, 68, 68, 0.4);
    color: #f87171;

    &:hover {
      background: rgba(239, 68, 68, 0.25);
    }
  }

  @media (max-width: 576px) {
    .btn-text {
      display: none;
    }
  }
}

.pagination-container {
  margin-top: 24px;
  display: flex;
  justify-content: flex-end;

  @media (max-width: 768px) {
    justify-content: center;
  }
}

:deep(.el-pagination) {
  --el-pagination-bg-color: transparent;
  --el-pagination-button-bg-color: rgba(157, 78, 221, 0.1);
  --el-pagination-hover-color: #c084fc;

  .btn-prev,
  .btn-next,
  .el-pager li {
    background: rgba(157, 78, 221, 0.1);
    border: 1px solid rgba(157, 78, 221, 0.3);
    color: #a0a0c0;
    border-radius: 8px;
    min-width: 32px;
    height: 32px;

    &:hover {
      background: rgba(157, 78, 221, 0.2);
      color: #c084fc;
    }

    &.active {
      background: linear-gradient(135deg, #6546b4, #9d4edd);
      color: #fff;
      border-color: transparent;
    }
  }

  .el-pagination__total,
  .el-pagination__jump {
    color: #a0a0c0;
  }
}

:deep(.custom-dialog) {
  --el-dialog-bg-color: rgba(18, 14, 33, 0.98);
  --el-dialog-border-radius: 20px;

  .el-dialog__header {
    border-bottom: 1px solid rgba(157, 78, 221, 0.2);
    padding: 20px 24px;

    .el-dialog__title {
      color: #fff;
      font-weight: 600;
    }
  }

  .el-dialog__body {
    padding: 24px;
  }

  .el-dialog__footer {
    border-top: 1px solid rgba(157, 78, 221, 0.2);
    padding: 16px 24px;
  }
}

:deep(.el-form-item__label) {
  color: #a0a0c0;
  font-weight: 500;
}

:deep(.el-input__wrapper) {
  background: rgba(26, 21, 53, 0.8);
  border: 1px solid rgba(157, 78, 221, 0.3);
  border-radius: 10px;
  box-shadow: none;

  &:hover {
    border-color: rgba(157, 78, 221, 0.6);
  }

  &.is-focus {
    border-color: #9d4edd;
    box-shadow: 0 0 0 2px rgba(157, 78, 221, 0.2);
  }

  .el-input__inner {
    color: #fff;
    background: transparent;

    &::placeholder {
      color: #5a5a7a;
    }
  }
}

:deep(.el-textarea__inner) {
  background: rgba(26, 21, 53, 0.8);
  border: 1px solid rgba(157, 78, 221, 0.3);
  border-radius: 10px;
  color: #fff;

  &:hover {
    border-color: rgba(157, 78, 221, 0.6);
  }

  &:focus {
    border-color: #9d4edd;
    box-shadow: 0 0 0 2px rgba(157, 78, 221, 0.2);
  }
}

.dialog-btn {
  padding: 10px 20px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
  margin-left: 12px;

  &.cancel-btn {
    background: rgba(157, 78, 221, 0.15);
    border: 1px solid rgba(157, 78, 221, 0.4);
    color: #a0a0c0;

    &:hover {
      background: rgba(157, 78, 221, 0.25);
      color: #c084fc;
    }
  }

  &.confirm-btn {
    background: linear-gradient(135deg, #6546b4, #9d4edd);
    color: #fff;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 15px rgba(157, 78, 221, 0.4);
    }
  }
}

:deep(.el-button) {
  border-radius: 10px;
  padding: 10px 20px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 500;
}

:deep(.el-button--primary) {
  background: linear-gradient(135deg, #6546b4, #9d4edd);
  border: none;

  &:hover {
    transform: translateY(-1px);
  }
}

:deep(.el-button--success) {
  background: linear-gradient(135deg, #10b981, #34d399);
  border: none;

  &:hover {
    transform: translateY(-1px);
  }
}

@media (max-width: 480px) {
  .btn-text {
    display: none;
  }
}
</style>

<!-- 非 scoped 全局样式 -->
<style lang="scss">
.el-dialog {
  --el-dialog-bg-color: rgba(18, 14, 33, 0.98) !important;
}

body>.el-overlay:has(.custom-dialog) .el-dialog__body {
  background: rgba(18, 14, 33, 0.98) !important;
}

.child-dialog {
  z-index: 3000 !important;
}

body>.el-overlay:has(.child-dialog) {
  z-index: 3000 !important;
}

body>.el-overlay:has(.child-dialog) .el-dialog {
  --el-dialog-bg-color: rgba(18, 14, 33, 0.98) !important;
  border: 1px solid rgba(157, 78, 221, 0.4) !important;
  border-radius: 20px;
  background: rgba(18, 14, 33, 0.98) !important;
}

body>.el-overlay:has(.child-dialog) .el-dialog__header {
  border-bottom: 1px solid rgba(157, 78, 221, 0.2);
  padding: 20px 24px;
  background: transparent !important;
}

body>.el-overlay:has(.child-dialog) .el-dialog__title {
  color: #ffffff !important;
  font-weight: 600;
}

body>.el-overlay:has(.child-dialog) .el-dialog__body {
  padding: 24px;
  color: #e0e0e0;
  background: rgba(18, 14, 33, 0.98) !important;
}

body>.el-overlay:has(.child-dialog) .el-dialog__footer {
  border-top: 1px solid rgba(157, 78, 221, 0.2);
  padding: 16px 24px;
  background: transparent !important;
}

body>.el-overlay:has(.child-dialog) .el-input__wrapper {
  background: rgba(26, 21, 53, 0.8) !important;
  border: 1px solid rgba(157, 78, 221, 0.3) !important;
  box-shadow: none !important;
  border-radius: 10px;
}

body>.el-overlay:has(.child-dialog) .el-input__wrapper:hover {
  border-color: rgba(157, 78, 221, 0.6) !important;
}

body>.el-overlay:has(.child-dialog) .el-input__wrapper.is-focus {
  border-color: #9d4edd !important;
  box-shadow: 0 0 0 2px rgba(157, 78, 221, 0.2) !important;
}

body>.el-overlay:has(.child-dialog) .el-input__inner {
  color: #fff !important;
  background: transparent !important;
}

body>.el-overlay:has(.child-dialog) .el-textarea__inner {
  background: rgba(26, 21, 53, 0.8) !important;
  border: 1px solid rgba(157, 78, 221, 0.3) !important;
  color: #fff !important;
  border-radius: 10px;
}

body>.el-overlay:has(.child-dialog) .el-upload-dragger {
  background: rgba(26, 21, 53, 0.6) !important;
  border-color: rgba(157, 78, 221, 0.4) !important;
}

body>.el-overlay:has(.child-dialog) .el-tabs__item {
  color: #a0a0c0 !important;
}

body>.el-overlay:has(.child-dialog) .el-tabs__item.is-active {
  color: #c084fc !important;
}

body>.el-overlay:has(.child-dialog) .el-tabs__active-bar {
  background-color: #9d4edd !important;
}

body>.el-overlay:has(.child-dialog) .el-form-item__label {
  color: #a0a0c0 !important;
}

body>.el-overlay:has(.child-dialog) .el-table {
  background-color: transparent !important;
  --el-table-bg-color: transparent !important;
  --el-table-tr-bg-color: transparent !important;
}

body>.el-overlay:has(.child-dialog) .el-table__body-wrapper {
  background-color: transparent !important;
}
</style>